export const optionalFieldsData = {
  subject: {
    options: []
  },
  levelOfEducation: {
    options: [{
      label: 'none'
    }, {
      label: 'jhs'
    }, {
      label: 'hs'
    }, {
      label: 'a'
    }, {
      label: 'b'
    }, {
      label: 'm'
    }, {
      label: 'p'
    }, {
      label: 'other'
    }]
  },
  workExperience: {
    options: [{
      label: '0yrs'
    }, {
      label: '1-5yrs'
    }, {
      label: '6-10yrs'
    }, {
      label: '11-15yrs'
    }, {
      label: '16-20yrs'
    }, {
      label: '20+yrs'
    }]
  },
  learningType: {
    options: [{
      label: 'Courses'
    }, {
      label: 'Boot Camps'
    }, {
      label: 'Degrees'
    }, {
      label: 'Executive Education'
    }, {
      label: 'unsure'
    }]
  },
  gender: {
    options: [{
      label: 'm'
    }, {
      label: 'f'
    }, {
      label: 'o'
    }]
  }
};
export const defaultSubjectList = [{
  name: 'Business & Management'
}, {
  name: 'Computer Science'
}, {
  name: 'Engineering'
}, {
  name: 'Social Sciences'
}, {
  name: 'Data Analysis & Statistics'
}, {
  name: 'Economics & Finance'
}, {
  name: 'Communication'
}, {
  name: 'Humanities'
}, {
  name: 'Science'
}, {
  name: 'Environmental Studies'
}, {
  name: 'Medicine'
}, {
  name: 'Biology & Life Sciences'
}, {
  name: 'Health & Safety'
}, {
  name: 'Education & Teacher Training'
}, {
  name: 'Art & Culture'
}, {
  name: 'Math'
}, {
  name: 'History'
}, {
  name: 'Design'
}, {
  name: 'Physics'
}, {
  name: 'Energy & Earth Sciences'
}, {
  name: 'Law'
}, {
  name: 'Philosophy & Ethics'
}, {
  name: 'Language'
}, {
  name: 'Electronics'
}, {
  name: 'Food & Nutrition'
}, {
  name: 'Architecture'
}, {
  name: 'Chemistry'
}, {
  name: 'Literature'
}, {
  name: 'Ethics'
}, {
  name: 'Music'
}, {
  name: 'Philanthropy'
}];
export const extendedProfileFields = ['subject', 'workExperience', 'learningType'];
//# sourceMappingURL=constants.js.map